import angular from 'angular'
import directive from './directive'

export default angular
  .module('ellipsis.composeBody', [])
  .directive('composeBody', directive)
